module.exports = __webpack_public_path__ + "static/img/70.a2caf675.png";